import axiosInstance from "./AxiosInstance";

export function getBillingReportApi(sId,param){
    const fparam=new URLSearchParams(param).toString()
    return axiosInstance.get(`api/reports/service-center-finance/${sId}?${fparam}`)
}

export function getExpenseReportApi(sId,param){
    const fparam=new URLSearchParams(param).toString()
    return axiosInstance.get(`api/reports/service-center-expenses/${sId}?${fparam}`)
}

export function getExpenseReportExportApi(sId,param) {
  const fparam = new URLSearchParams(param).toString();
  return axiosInstance.get(`api/reports/service-center-expenses/${sId}?${fparam}`, {
    responseType: "blob",
  });
}
export function getBillingReportExportApi(sId,param) {
  const fparam = new URLSearchParams(param).toString();
  return axiosInstance.get(`api/reports/service-center-finance/${sId}?${fparam}`, {
    responseType: "blob",
  });
}

